import { ReactNode } from "react";

interface AccountPageProps {
  children: ReactNode;
  className?: string;
}

const AccountPage = ({ children, className = "" }: AccountPageProps) => {
  return (
    <div className={`w-full max-w-2xl mx-auto px-4 py-6 font-nunito ${className}`}>
      {children}
    </div>
  );
};

export default AccountPage;
